import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import { NeutralColors, UIPalette } from "../../constants/colors";
import React from 'react';
import PropTypes from 'prop-types';
import { targetPropType } from "../../constants/target";
import { CloseIcon } from "../common/close-icon";
import { StyledContainer, StyledCtaLink, StyledMessage, StyledMessageContainer } from "./banner-link.styles";
import { StyledDismissContainer } from "./base.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CtaLink = function CtaLink(_ref) {
  var url = _ref.url,
    text = _ref.text,
    target = _ref.target,
    onClick = _ref.onClick;
  if (!url || !text) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [' ', /*#__PURE__*/_jsx(StyledCtaLink, {
      href: url,
      onClick: onClick,
      onAuxClick: onClick,
      rel: target ? 'noopener noreferrer' : null,
      target: target,
      "data-gtm-event": "cta_promo",
      children: text
    })]
  });
};
CtaLink.displayName = 'CtaLink';
CtaLink.propTypes = {
  onClick: PropTypes.func,
  target: targetPropType,
  text: PropTypes.string,
  url: PropTypes.string
};
CtaLink.defaultProps = {
  onClick: null,
  target: null,
  text: null,
  url: null
};
var BannerLink = function BannerLink(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    color = _ref2.color,
    cta = _ref2.cta,
    dismissible = _ref2.dismissible,
    dismissButtonLabel = _ref2.dismissButtonLabel,
    message = _ref2.message,
    onDismiss = _ref2.onDismiss;
  return /*#__PURE__*/_jsxs(StyledContainer, {
    $backgroundColor: backgroundColor,
    $color: color,
    $dismissible: dismissible,
    children: [/*#__PURE__*/_jsxs(StyledMessageContainer, {
      children: [/*#__PURE__*/_jsx(StyledMessage, {
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/_jsx(CtaLink, _objectSpread({}, cta))]
    }), dismissible && /*#__PURE__*/_jsx(StyledDismissContainer, {
      "data-testid": "banner-link-dismissible-icon",
      onClick: onDismiss,
      "aria-label": dismissButtonLabel,
      children: /*#__PURE__*/_jsx(CloseIcon, {
        fill: color
      })
    })]
  });
};
BannerLink.propTypes = {
  backgroundColor: PropTypes.string,
  color: PropTypes.string,
  cta: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
    target: targetPropType
  }),
  dismissible: PropTypes.bool,
  dismissButtonLabel: PropTypes.string,
  message: PropTypes.node.isRequired,
  onDismiss: PropTypes.func
};
BannerLink.defaultProps = {
  backgroundColor: UIPalette.Emerald,
  color: NeutralColors.White,
  cta: null,
  dismissible: false,
  dismissButtonLabel: 'Dismiss banner',
  onDismiss: null
};
BannerLink.displayName = 'BannerLink';
export default BannerLink;